import { useState, useEffect } from "react";
import { fetchBatchStatuses } from "@/api/fetchBatchStatuses/fetchBatchStatuses";
import { BatchStatus } from "@/api/fetchBatchStatuses/types";

export function useBatchStatuses() {
  const [statuses, setStatuses] = useState<BatchStatus[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadStatuses = async () => {
      try {
        setLoading(true);
        const response = await fetchBatchStatuses();
        setStatuses(response.data);
        setError(null);
      } catch (err) {
        setError(err instanceof Error ? err.message : "Failed to fetch batch statuses");
      } finally {
        setLoading(false);
      }
    };

    loadStatuses();
  }, []);

  return {
    statuses,
    loading,
    error,
  };
}
